import React from 'react';

import { EUserStoreRole } from '@domain/enums/common/userStore/EUserStoreRole';

import { useStoreConfig } from '@helpers/hooks/useStoreConfig';
import { useConfig } from '@helpers/hooks/useConfig';

import Content from '@components/Dashboard/AccessManagement/Onboarding/NewMember';
import NoAccess from '@components/common/core/Utils/NoAccess';

const NewMember: React.FC = () => {
  const { accessManagementData } = useStoreConfig();
  const { isInternalTeam } = useConfig();

  const isStoreOwner = accessManagementData?.role === EUserStoreRole.OWNER;

  if (!isStoreOwner && !isInternalTeam) {
    return <NoAccess />;
  }

  return <Content />;
};

export default NewMember;
